import React from 'react'
import PropTypes from 'prop-types'
import { Layout, SEO, SliceZone, Tag } from 'components'
import StyledPageHeader from 'components/StyledPageHeader/index.css'
import TextLink from 'lib/TextLink'
import styled from 'styled-components'
import relResolver from 'helpers/relResolver'
import { renderColor } from 'helpers/styles'
import { graphql } from 'gatsby'

const StyledSlices = styled.div``

const StyledAuthor = styled.span`
  color: ${props => renderColor(props.theme.colors, 'yellow')};
`

const StyledRelatedLinks = styled.section`
  background: ${props => renderColor(props.theme.colors, 'white')};
  padding: 36px 18px;
  margin-top: 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > span {
    color: ${props => renderColor(props.theme.colors, 'grey')};
    font-size: 13px;
    margin-bottom: 36px;
  }

  a {
    font-size: 18px;
    font-weight: 700;
  }
`

function News({ data: { prismicNewsArticle } }) {
  const {
    data: {
      page_title,
      meta_title,
      meta_description,
      meta_images,
      body,
      publishing_date,
      related_links,
    },
    type,
    tags,
  } = prismicNewsArticle

  const { full_name } = relResolver(prismicNewsArticle.data, 'author')

  return (
    <Layout>
      <SEO title={meta_title} desc={meta_description} images={meta_images} />
      {page_title && page_title.text && (
        <StyledPageHeader>
          <Tag centered>{tags.join(', ')}</Tag>
          <h1>{page_title.text}</h1>
          <StyledAuthor>
            Written by <strong>{full_name.text}</strong>, {publishing_date}
          </StyledAuthor>
        </StyledPageHeader>
      )}
      <StyledSlices>
        <SliceZone allSlices={body} type={type} />
      </StyledSlices>
      <StyledRelatedLinks>
        <span>Related links</span>
        {related_links.map(({ link, link_text }, index) => (
          <TextLink key={`link_${index}`} target={link.target} href={link.url}>
            {link_text}
          </TextLink>
        ))}
      </StyledRelatedLinks>
    </Layout>
  )
}

export default News

News.defaultProps = {}

News.propTypes = {
  data: PropTypes.shape({
    prismicNewsArticle: PropTypes.shape({
      data: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
}

export const newsQuery = graphql`
  query($uid: String!) {
    prismicNewsArticle(uid: { eq: $uid }) {
      id
      uid
      type
      tags
      data {
        publishing_date(formatString: "Do MMMM YYYY")
        meta_title
        meta_description
        meta_images {
          image {
            url
            dimensions {
              width
              height
            }
          }
        }
        page_title {
          text
        }

        author {
          id
          document {
            id
            data {
              full_name {
                text
              }
            }
          }
        }

        related_links {
          link_text
          link {
            link_type
            url
            target
          }
        }

        body {
          ... on PrismicNewsArticleBodyParagraph {
            slice_type
            id
            primary {
              layout
              content {
                html
              }
            }
          }

          ... on PrismicNewsArticleBodyParagraphImage {
            slice_type
            id
            primary {
              content {
                html
              }
              image_position
              image {
                alt
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 700, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
